export default "__VITE_ASSET__c1a2281d__"